import React from 'react';
import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumbs = ({ breadcrumbMap }) => {
  const location = useLocation();

  // Split the current URL into path segments
  const pathSnippets = location.pathname.split('/').filter((i) => i);

  // Helper to traverse the breadcrumb map
  const getBreadcrumbName = (pathSnippets) => {
    let current = breadcrumbMap;
    const names = [];

    for (let snippet of pathSnippets) {
      if (current[snippet]) {
        // If the snippet exists in the map, add it to the breadcrumb list
        names.push({ path: snippet, name: current[snippet].name });
        current = current[snippet].children || {}; // Go to child map
      } else if (current['*'] && current['*'].dynamic) {
        // Handle dynamic segments with the '*' key and dynamic flag
        names.push({ path: snippet, name: current['*'].name.replace(':id', snippet) });
        current = current['*'].children || {}; // Move to children if any
      } else {
        break; // Stop if a segment isn't in the map
      }
    }

    return names;
  };

  const breadcrumbs = getBreadcrumbName(pathSnippets);
  const style = {
    fontSize: '14px',
    textDecoration: 'none'
  };

  return (
    <Breadcrumb style={{ padding: '20px' }}>
      {/* Static Home link */}
      <Breadcrumb.Item key="home">
        <Link style={style} to="/">Home</Link>
      </Breadcrumb.Item>
      {/* Dynamic breadcrumbs */}
      {breadcrumbs.map(({ path, name }, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
        const isLast = index === breadcrumbs.length - 1;

        return (
          <Breadcrumb.Item key={url}>
            {isLast ? (
              // Last breadcrumb element - not a link and black color
              <span style={{ ...style, color: 'black', cursor: 'default' }}>{name}</span>
            ) : (
              // Normal breadcrumb elements - links
              <Link style={style} to={url}>{name}</Link>
            )}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
